export class Environment {
    static backendUrl() {
        const url = process.env.REACT_APP_BACKEND_API_URL;

        return url;
    }
}